import React, { Component } from "react";
import { motion } from "framer-motion";
import "../styles/detalle70.css";

class LeyGCG extends Component {
  documentos = [
    {
      titulo: "Acta del Presupuesto Anual para el Ejercicio Fiscal 2023",
      archivo: "/PDF/ActasLGCG/Acta_Presupuesto_2023.pdf",
      miniatura: "/images/pdf-thumb.png"
    },
    {
      titulo: "Acta del Presupuesto Anual para el Ejercicio Fiscal 2024",
      archivo: "/PDF/ActasLGCG/Acta_Presupuesto_2024.pdf",
      miniatura: "/images/pdf-thumb.png"
    },
    {
      titulo: "Acta del Presupuesto Anual para el Ejercicio Fiscal 2025",
      archivo: "/PDF/ActasLGCG/Acta_Presupuesto_2025.pdf",
      miniatura: "/images/pdf-thumb.png"
    },
    {
      titulo: "Acta del Presupuesto Anual para el Ejercicio Fiscal 2026",
      archivo: "/PDF/ActasLGCG/Acta_Presupuesto_2026.pdf",
      miniatura: "/images/pdf-thumb.png"
    }
  ];

  renderCard = (doc, index) => {
    return (
      <div key={index} className="col-lg-3 col-md-6 col-sm-12 mb-4">
        <motion.div
          className="pdf-card"
          initial={{ opacity: 0, y: 40 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ delay: index * 0.1 }}
          whileHover={{ scale: 1.05 }}
        >
          <div className="pdf-thumb">
            <img src={doc.miniatura} alt={doc.titulo} />
          </div>

          <h3 className="pdf-title">{doc.titulo}</h3>

          <a
            href={doc.archivo}
            target="_blank"
            rel="noopener noreferrer"
            className="pdf-btn"
          >
            Ver PDF
          </a>
        </motion.div>
      </div>
    );
  };

  render() {
    return (
      <div id="main" className="wrapper style1">
        <div className="container">
          <header className="major">
            <h2>Ley General de Contabilidad Gubernamental</h2>
          </header>

          <div className="row">
            {this.documentos.map(this.renderCard)}
          </div>
        </div>
      </div>
    );
  }
}

export default LeyGCG;